<template>
  <div>
    <el-card>
      <h3>用户账号管理</h3>
      <el-table :data="tableData" border stripe style="margin-top:15px;">
        <el-table-column prop="id" label="账号ID" width="80" />
        <el-table-column prop="nickname" label="昵称" />
        <!-- 👇 邮箱列已删除 👇 -->
        <el-table-column prop="phone" label="手机号" width="130" />
        <el-table-column prop="groupMaxNum" label="小组人数上限" width="120"/>
        <el-table-column prop="imgMaxCount" label="图片上传张数上限" width="140"/>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <span :style="{color: scope.row.status === 1 ? '#67c23a' : '#f56c6c'}">
              {{ scope.row.status === 1 ? '正常' : '已禁用' }}
            </span>
          </template>
        </el-table-column>
        <!-- 👇 操作列加宽，并新增查看足迹按钮 👇 -->
        <el-table-column label="操作" width="320">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="goFootprints(scope.row.phone)">查看足迹</el-button>
            <el-button size="mini" @click="openEdit(scope.row)">编辑权限</el-button>
            <el-button
              size="mini"
              :type="scope.row.status === 1 ? 'danger' : 'success'"
              @click="toggleStatus(scope.row)"
            >
              {{ scope.row.status === 1 ? '禁用账号' : '启用账号' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:15px;text-align:right;"
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="fetchUserList"
      />
    </el-card>

    <el-dialog title="修改用户权限" :visible.sync="editDialog">
      <el-form :model="editForm" label-width="120px">
        <el-form-item label="小组人数上限">
          <el-input v-model.number="editForm.groupMaxNum" type="number"></el-input>
        </el-form-item>
        <el-form-item label="图片上传张数上限">
          <el-input v-model.number="editForm.imgMaxCount" type="number"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取消</el-button>
        <el-button type="primary" @click="saveUserAuth">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import adminRequest from '@/utils/adminRequest'
export default {
  data() {
    return {
      tableData: [],
      editDialog: false,
      editForm: {},
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.fetchUserList()
  },
  methods: {
    async fetchUserList() {
      try {
        const res = await adminRequest.get('/userList', {
          params: { page: this.currentPage, pageSize: this.pageSize }
        })
        this.tableData = res.data?.list || []
        this.total = res.data?.total || 0
      } catch (err) {
        console.error('请求用户列表失败', err)
        this.tableData = []
        this.total = 0
      }
    },
    // 👇 新增跳转方法 👇
    goFootprints(phone) {
      this.$router.push({ path: '/sys-console-x9/content', query: { phone } })
    },
    openEdit(row) {
      this.editForm = { ...row }
      this.editDialog = true
    },
    async saveUserAuth() {
      try {
        const res = await adminRequest.post('/userAuth', {
          userId: this.editForm.id,
          groupMaxNum: this.editForm.groupMaxNum,
          imgMaxCount: this.editForm.imgMaxCount
        })
        if (res.success) {
          this.editDialog = false
          this.$message.success('权限更新成功')
          this.fetchUserList()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('保存失败')
      }
    },
    async toggleStatus(row) {
      try {
        const res = await adminRequest.post('/userStatus', {
          userId: row.id,
          status: row.status === 1 ? 0 : 1
        })
        if (res.success) {
          this.$message.success('账号状态修改成功')
          this.fetchUserList()
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$message.error('操作失败')
      }
    }
  }
}
</script>